import { render } from "./EventDetails.vue?vue&type=template&id=b0c5e434"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"
script.render = render

export default script